/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskSubtaskInputDto
 */
export interface TaskSubtaskInputDto {
    /**
     * 
     * @type {string}
     * @memberof TaskSubtaskInputDto
     */
    name: string;
    /**
     * 1-based order; omitted → position in the array
     * @type {number}
     * @memberof TaskSubtaskInputDto
     */
    sequence?: number;
}

/**
 * Check if a given object implements the TaskSubtaskInputDto interface.
 */
export function instanceOfTaskSubtaskInputDto(value: object): value is TaskSubtaskInputDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function TaskSubtaskInputDtoFromJSON(json: any): TaskSubtaskInputDto {
    return TaskSubtaskInputDtoFromJSONTyped(json, false);
}

export function TaskSubtaskInputDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskSubtaskInputDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'sequence': json['sequence'] == null ? undefined : json['sequence'],
    };
}

export function TaskSubtaskInputDtoToJSON(json: any): TaskSubtaskInputDto {
    return TaskSubtaskInputDtoToJSONTyped(json, false);
}

export function TaskSubtaskInputDtoToJSONTyped(value?: TaskSubtaskInputDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'sequence': value['sequence'],
    };
}

